interface IconSearchProps {
  className?: string;
  fill?: boolean;
  duotone?: boolean;
}

const IconSearch: FC<IconSearchProps> = ({ className, duotone = true }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      className={className}
    >
      <path
        opacity={duotone ? '0.5' : '1'}
        d='M11.5986 21C16.8453 21 21.0986 16.7467 21.0986 11.5C21.0986 6.25329 16.8453 2 11.5986 2C6.35193 2 2.09863 6.25329 2.09863 11.5C2.09863 16.7467 6.35193 21 11.5986 21Z'
        stroke='#E0E2E1'
        strokeWidth='1.5'
      />
      <path d='M20.0986 20L22.0986 22' stroke='#E0E2E1' strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
};

export default IconSearch;
